import { ApplicationElement, html } from '@beunity/lit-components';
import style from './style.lit.css';

/**
 * Breadcrumbs for navigation.
 *
 * @prop items - Internal array of breadcrumb items
 *
 * @slot default - For items (item will most likely be an `<a>` element)
 */

export default class Breadcrumbs extends ApplicationElement {
  static styles = [ApplicationElement.styles, style];

  static properties = {
    items: { type: Array, state: true },
  };

  divider() {
    return html`<bu-icon name="angle-right:light"></bu-icon>`;
  }

  setItemAttributes(item) {
    const text = item.text.trim();

    text.length > 10
      ? item.classList.add('long')
      : item.classList.remove('long');
    item.setAttribute('title', text);
  }

  onSlotChange(e) {
    const breadcrumbs = e.target.assignedElements({ flatten: true });
    this.items = [];

    breadcrumbs.forEach(el => {
      this.setItemAttributes(el);
      this.items.push(el.cloneNode(true));
      this.items.push(this.divider());
    });

    this.items.pop(); /* Remove the last divider */
  }

  render() {
    return html`
      <slot @slotchange=${this.onSlotChange} hidden></slot>
      ${this.items}
    `;
  }
}

Breadcrumbs.registerTagName('bu-breadcrumbs');

customElements.get('bu-breadcrumbs') ||
  customElements.define('bu-breadcrumbs', Breadcrumbs);
